<section class="cta-section theme-bg-light py-5">
    <div class="container single-col-max-width">
        <h2 class="heading">{{legal.name}}</h2>
        <div class="intro" [innerHTML]='legal.html'></div>
        <!--//container-->
    </div>
</section>